import * as Yup from "yup";

export const bootImageValidationSchema = Yup.object().shape({
  rentalPeriod: Yup.number()
    .required("Số giờ không được để trống")
    .min(1, "Số giờ tối thiểu là 1")
    .integer("Số giờ không hợp lệ"),
});
